import React from "react";
import { withTranslation } from "react-i18next";
import AlertCircle from "../../../assets/images/alert-circle-black.svg";
import styles from "../staff.module.scss";

const PmsMembersAlert = ({ officeDetail, officeActive, onRedirect, t }) => {
  if (!officeDetail?.isConnectedWithSikka || !officeActive) {
    return null;
  }

  return (
    <div className={styles["staff_yellow_heading"]}>
      <img src={AlertCircle} alt="AlertCircle" />
      <span className={styles["staff_alert_text"]}>
        {t("pmsMembers.invitePmsStaff")}
      </span>
      <button
        className={`back-btn ${styles["staff_click_btn"]}`}
        onClick={onRedirect}
      >
        {t("pmsMembers.clickHere")}
      </button>
    </div>
  );
};

export default withTranslation()(PmsMembersAlert);

